import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Calendar, MapPin, Users, BookOpen, Download } from 'lucide-react';

const PastConference = () => {
  const pastConferences = [
    {
      id: 1,
      name: "International Conference on Latest Trends in Innovation ICLTI-2024",
      date: "28th April 2024",
      venue: "IIT Alumni Industry Interaction Center, IIT Madras Research Park, 10th Floor, C Block, Kanagam Rd, Tharamani, Chennai, Tamil Nadu 600113",
      organizer: "ESN Publications",
      country: "India",
      editor: "Dr. Rajesh Kumar",
      isbn: "978-93-90781-24-9",
      about: "ICLTI-2024 provides a platform for knowledge sharing and networking. They bring together experts and professionals from various fields. ICLTI-2024 feature keynote speakers, panel discussions, and workshops. They offer opportunities for learning and professional development. ICLTI-2024 facilitates collaboration and innovation. They help attendees stay updated on industry trends. Conferences can be held in-person or virtually. They provide a space for idea exchange and feedback. ICLTI-2024 can lead to new business opportunities and partnerships. They foster growth and advancement in various industries.",
      photoLink: "https://drive.google.com/drive/folders/1FB7rYkOvy1lzTHYnnLtwroSx0JdA4K9z?usp=drive_link",
      photos: Array(7).fill(0).map((_, i) => `/conference/Conf1/img${i + 1}.jpg`)
    },
    {
      id: 2,
      name: "UAE International Conference on Multidisciplinary Research and Innovation (ICMRI 2023)",
      date: "January 23rd to 25th, 2023",
      venue: "UAE",
      organizer: "ESN Publications",
      country: "UAE",
      editor: "Prof. Anita Sharma",
      isbn: "978-93-90781-23-2",
      about: "ICMRI 2023 provide a platform for networking and partnership building. They offer opportunities for learning from industry experts. ICMRI 2023 feature keynote speakers, panel discussions, and workshops. They help attendees stay updated on industry trends and best practices. ICMRI 2023 can lead to new business opportunities and partnerships. They provide a space for idea exchange and feedback. ICMRI 2023 can be held in-person or virtually. They facilitate collaboration and innovation in various industries. ICMRI 2023 can lead to increased productivity and efficiency. They foster growth and advancement in business and industry.",
      photoLink: "https://drive.google.com/drive/folders/12Zy_mFt1m2_6_-tBpmuPgmQAzUXY_H-b?usp=share_link",
      photos: Array(8).fill(0).map((_, i) => `/conference/conf2/img${i + 1}.jpg`)
    },
    {
      id: 3,
      name: "International Conference on Multidisciplinary Research and Development (ICMRD - 2023)",
      date: "September 13th - 15th, 2023",
      venue: "Universiti Teknologi MARA, Puncak Alam Campus, Selangor, Malaysia",
      organizer: "ESN Publications",
      country: "Malaysia",
      editor: "Dr. Vikram Singh",
      isbn: "978-93-90781-22-5",
      about: "ICMRD - 2023 provide opportunities for learning and growth. They offer a platform for networking with peers and experts. ICMRD – 2023 feature keynote speakers, panel discussions, and workshops. They help attendees stay updated on industry trends and best practices. ICMRD – 2023 can lead to new skills and knowledge. They provide a space for idea exchange and feedback. ICMRD – 2023 can be held in-person or virtually. They facilitate collaboration and innovation in various industries. ICMRD – 2023 can lead to career advancement and professional growth. They foster a sense of community and connection among professionals.",
      photoLink: "https://drive.google.com/drive/folders/13l9bIFDQkdOfPTxf8k5fnV3fyxBjNqPe?usp=drive_link",
      photos: Array(8).fill(0).map((_, i) => `/conference/conf3/img${i + 1}.jpg`)
    },
    {
      id: 4,
      name: "International Conference on Multidisciplinary Research and Innovation (ICMRI- 2022)",
      date: "March 03rd to 05th, 2022",
      venue: "Taj Vivanta, GOA, India",
      organizer: "ESN Publications",
      country: "India",
      editor: "Dr. Priya Nair",
      isbn: "978-93-90781-21-8",
      about: "ICMRI- 2022 promotes research and knowledge sharing. They provide a platform for scholars to present their work. ICMRI- 2022 facilitates discussion and feedback on research papers. They help attendees stay updated on the latest research trends. ICMRI- 2022 can lead to new research collaborations and projects. They offer opportunities for networking with peers and experts. Conferences can be held in various formats, including virtual and hybrid. They provide a space for intellectual exchange and debate. ICMRI- 2022 can lead to publications in academic journals. They foster academic excellence and innovation.",
      photoLink: "https://drive.google.com/drive/folders/1kkzdgUqZtX8dVnkG9QQAxPpDPsgbbpaG?usp=sharing",
      photos: Array(7).fill(0).map((_, i) => `/conference/conf4/img${i + 1}.jpg`)
    }
  ];

  return (
    <div style={{ backgroundColor: '#f8fafc', minHeight: '100vh' }}>
      {/* Header */}
      <div style={{ padding: '40px 24px 0' }}>
        <div className="container-custom">
          <Link to="/conference" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', color: '#667eea', textDecoration: 'none', marginBottom: '30px', fontWeight: '600' }}>
            <ArrowLeft size={20} />
            <span>Back to Conferences</span>
          </Link>
          
          <div style={{ textAlign: 'center', marginBottom: '60px' }}>
            <div style={{
              display: 'inline-block',
              background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
              color: 'white',
              padding: '12px 30px',
              borderRadius: '25px',
              fontSize: '1rem',
              fontWeight: 'bold',
              marginBottom: '20px'
            }}>
              📚 CONFERENCE ARCHIVE
            </div>
            <h1 style={{ color: '#2d3748', fontSize: '3rem', fontWeight: 700, marginBottom: '20px' }}>Past Conferences</h1>
            <p style={{ color: '#718096', fontSize: '1.2rem', maxWidth: '600px', margin: '0 auto' }}>
              Explore our successful conferences and their proceedings from previous years
            </p>
          </div>
        </div>
      </div>

      {/* Past Conferences List */}
      <div className="container-custom" style={{ padding: '0 24px 80px' }}>
        <div style={{ display: 'grid', gap: '50px' }}>
          {pastConferences.map((conference, index) => (
            <div key={conference.id} style={{ 
              background: index % 2 === 0 
                ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' 
                : 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)', 
              padding: '3px', 
              borderRadius: '20px', 
              boxShadow: '0 8px 32px rgba(102, 126, 234, 0.2)' 
            }}>
              <div style={{ 
                backgroundColor: 'white', 
                padding: '50px', 
                borderRadius: '17px'
              }}>
                {/* Conference Header */}
                <div style={{ marginBottom: '40px' }}>
                  <h2 style={{ color: '#2d3748', fontSize: '2.2rem', fontWeight: 700, marginBottom: '20px' }}>
                    {conference.name}
                  </h2>
                  
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px', marginBottom: '30px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      <Calendar size={20} color="#667eea" />
                      <span style={{ color: '#4a5568', fontWeight: 600 }}>{conference.date}</span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      <MapPin size={20} color="#667eea" />
                      <span style={{ color: '#4a5568', fontWeight: 600 }}>{conference.venue}</span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      <Users size={20} color="#667eea" />
                      <span style={{ color: '#4a5568', fontWeight: 600 }}>Organizer: {conference.organizer}</span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      <span style={{ fontSize: '20px' }}>🌍</span>
                      <span style={{ color: '#4a5568', fontWeight: 600 }}>Country: {conference.country}</span>
                    </div>
                  </div>
                </div>

                {/* Proceedings Info */}
                <div style={{ 
                  background: '#f7fafc', 
                  padding: '30px', 
                  borderRadius: '12px', 
                  marginBottom: '40px',
                  border: '2px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#2d3748', fontSize: '1.5rem', fontWeight: 700, marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <BookOpen size={24} color="#667eea" />
                    Proceedings Book
                  </h3>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '20px' }}>
                    <div>
                      <h4 style={{ color: '#667eea', fontSize: '0.9rem', fontWeight: 600, marginBottom: '8px', textTransform: 'uppercase' }}>Editor</h4>
                      <p style={{ color: '#2d3748', fontWeight: 600, fontSize: '1.1rem' }}>{conference.editor}</p>
                    </div>
                    <div>
                      <h4 style={{ color: '#667eea', fontSize: '0.9rem', fontWeight: 600, marginBottom: '8px', textTransform: 'uppercase' }}>ISBN</h4>
                      <p style={{ color: '#2d3748', fontWeight: 600, fontSize: '1.1rem', fontFamily: 'monospace' }}>{conference.isbn}</p>
                    </div>
                    <div>
                      <button style={{
                        padding: '12px 24px',
                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                        color: 'white',
                        border: 'none',
                        borderRadius: '25px',
                        fontSize: '1rem',
                        fontWeight: 600,
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        transition: 'transform 0.2s ease'
                      }}
                      onMouseEnter={(e) => e.target.style.transform = 'translateY(-2px)'}
                      onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}>
                        <Download size={18} />
                        Download Proceedings
                      </button>
                    </div>
                  </div>
                </div>

                {/* About Conference */}
                <div style={{ marginBottom: '40px' }}>
                  <h3 style={{ color: '#2d3748', fontSize: '1.5rem', fontWeight: 700, marginBottom: '20px' }}>About Conference</h3>
                  <p style={{ color: '#4a5568', fontSize: '1.1rem', lineHeight: '1.7' }}>{conference.about}</p>
                </div>

                {/* Photo Gallery */}
                <div>
                  <h3 style={{ color: '#2d3748', fontSize: '1.5rem', fontWeight: 700, marginBottom: '30px' }}>Conference Gallery</h3>
                  <div style={{ marginBottom: '20px' }}>
                    <a 
                      href={conference.photoLink} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '10px',
                        padding: '12px 24px',
                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                        color: 'white',
                        textDecoration: 'none',
                        borderRadius: '25px',
                        fontSize: '1rem',
                        fontWeight: 600,
                        transition: 'transform 0.2s ease'
                      }}
                      onMouseEnter={(e) => e.target.style.transform = 'translateY(-2px)'}
                      onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
                    >
                      📸 View All Photos
                    </a>
                  </div>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '20px' }}>
                    {conference.photos.map((photo, photoIndex) => (
                      <div key={photoIndex} style={{
                        height: '200px',
                        borderRadius: '12px',
                        overflow: 'hidden',
                        backgroundColor: '#e2e8f0',
                        cursor: 'pointer',
                        transition: 'transform 0.2s ease'
                      }}
                      onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                      onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}>
                        <img 
                          src={photo} 
                          alt={`Conference ${conference.id} Photo ${photoIndex + 1}`}
                          style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover'
                          }}
                          onError={(e) => {
                            e.target.style.display = 'none';
                            e.target.parentElement.innerHTML = `<div style="display: flex; align-items: center; justify-content: center; height: 100%; color: #718096; font-size: 0.9rem; font-weight: 600;">📸 Photo ${photoIndex + 1}</div>`;
                          }}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PastConference;